module.exports = __webpack_public_path__ + "img/user-viajes-2.77c65c5a.svg";